import s from './selected-club.sass'
import { TYPE_PREMIUM } from './club-select'
import { includeName } from '../../helpers/includes'
import { IconConfirmSolid } from '../icons/confirm-solid'
import { IconPinSolid } from '../icons/pin-solid'
import { IconPremiumBadge } from '../icons/premium-badge'
import { IconProfileSolid } from '../icons/profile-solid'

const SelectedClub = ({
  thumbnail,
  name,
  address,
  type,
  isManned,
  includes,
  ...rest
}) => {
  return (
    <div className={s.container}>
      <img className={s.thumbnail} src={thumbnail.src} />
      <div className={s.data}>
        <div className={s.name}>{name}</div>
        <div className={s.info}><IconPinSolid /> {address.street}, {address.postalCode} {address.city}</div>
        <div className={s.info}><IconProfileSolid />{isManned ? 'Bemannat' : 'Obemannat'}</div>
        <div className={s.includeList}>
          {includes.map((include) => <span className={s.includeItem}>{includeName(include)}</span>)}
        </div>
        {type === TYPE_PREMIUM && <IconPremiumBadge className={s.premiumBadge} />}
        <div className={s.youAreTheChosenOne}>Valt gym <IconConfirmSolid /></div>
      </div>
    </div>
  )
}

export default SelectedClub



// WEBPACK FOOTER //
// ./components/signup-flow/selected-club.js